import React, { useCallback } from "react";
import { useFormikContext } from "formik";
import {
  HvGrid,
  HvRadio,
  HvRadioGroup,
} from "@hitachivantara/uikit-react-core";
import { useTranslation } from "react-i18next";
import { CameraTypes } from "lib/api";
import clsx from "clsx";
import RTSPContent from "../RTSPContent";
import OnvifContent from "../OnvifContent";
import useStyles from "./styles";
import VMSContent from "../VMSContent";

export interface TypeContentProps {
  type: string;
  mode: string;
}

const TypeContent: React.FC<TypeContentProps> = (props) => {
  const { t } = useTranslation("cameraAddEdit");
  const classes = useStyles();

  const { values, setFieldTouched, setFieldValue, setStatus } =
    useFormikContext<CameraFormData>();

  const setValueOnForm = useCallback(
    (
      property: string,
      selection: UserWithGroup | UserWithGroup[] | undefined
    ) => {
      setFieldTouched(property);
      setFieldValue(property, selection);
      // clearServerSideErrors
      setStatus({});
    },
    [setFieldTouched, setFieldValue, setStatus]
  );

  return (
    <>
      <HvGrid
        item
        container
        xs={12}
        className={clsx(classes.root, classes.fields)}
        style={{ marginBottom: 0 }}
      >
        <HvGrid xs={12} md={12} className={classes.gridPaddingOverRide}>
          <HvRadioGroup
            className={classes.gridHeight}
            label={t("cameraType.fields.cameraType")}
            orientation="horizontal"
            name="cameraType"
            required
            disabled={values.type === CameraTypes.VMS || props.mode === "edit"}
            value={values.type}
            onChange={(evt, value) => setValueOnForm("type", value)}
          >
            <HvRadio
              label={t("cameraType.fields.rtsp")}
              value={CameraTypes.RTSP}
            />
            <HvRadio
              label={t("cameraType.fields.onvif")}
              value={CameraTypes.Onvif}
            />
            {values.type === CameraTypes.VMS ? (
              <HvRadio
                disabled
                label={t("cameraType.fields.vms")}
                value={CameraTypes.VMS}
              />
            ) : (
              <></>
            )}
          </HvRadioGroup>
        </HvGrid>
        <HvGrid xs={12} md={12}>
          {values.type === CameraTypes.RTSP && (
            <>
              <RTSPContent mode={props.mode} />
            </>
          )}
          {values.type === CameraTypes.Onvif && (
            <>
              <OnvifContent mode={props.mode} />
            </>
          )}
          {values.type === CameraTypes.VMS && (
            <>
              <VMSContent mode={props.mode} />
            </>
          )}
        </HvGrid>
      </HvGrid>
    </>
  );
};

export default TypeContent;
